import { trackButtonClick } from '@/utils/analytics';
import React, { useEffect, useState } from 'react';
import { Col, Row, Button, Modal } from "react-bootstrap";

const Disclaimer = ({ data, provisionalSaleDuration, cms, pdpData }) => {

    const [showProvisionalSaleDate, setshowProvisionalSaleDateShow] = useState(false);

    const getFormatPrice = (amnt) => {
        if (amnt?.length === 0 || isNaN(amnt)) {
            return "";
        }
        return amnt?.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    };

    let newData = null;
    if (data) {
        const buyerPremiumPercentageTxt = "<span class='buyrPriumPrcntge'></span>" + pdpData.revisedBuyerPremiumPercentage + "%";
        const buyerPremiumAmountTxt = "<span class='BPReductionAmount'>" + getFormatPrice(pdpData.revisedBuyerPremium) + "</span>";

        var rawData = JSON.stringify(data)?.replace("<span class='buyrPriumPrcntge'></span>%", buyerPremiumPercentageTxt);
        rawData = rawData?.replace("<span class='BPReductionAmount'>$625</span>", buyerPremiumAmountTxt);
        newData = JSON.parse(rawData);
    }

    // Track click after Terms & Conditions element is injected into DOM
    useEffect(() => {
        if (!newData) return;

        const handleTermsClick = () => {
            trackButtonClick({
                eventName: "tc_from_disclaimers",
                eventCategory: "NEW-PDP",
                eventSource: "Disclaimer Section",
                eventLabel: `Property ID: ${pdpData?.propertyDetails?.propertyId} | type: pdpviews`
            });
        };

        const termsLink = document.getElementById('terms-conditions-link');
        if (termsLink) {
            termsLink.addEventListener('click', handleTermsClick);
        }

        return () => {
            if (termsLink) {
                termsLink.removeEventListener('click', handleTermsClick);
            }
        };
    }, [newData, pdpData?.propertyDetails?.propertyId]);

    if (!data) {
        return null;
    }

    return (

            <div className="propertyInfoBox mb30 tour-pdp-details p0">
                <Row className="propertyInfoBoxHeading p0"
                style={{padding:0}}>
                    <h3 className='propertyInfoBoxHeadingText' >
                        {cms?.DisclaimerHeading ? cms?.DisclaimerHeading : "Disclaimers" }
                    </h3>

                </Row>



                <div className='p25'>
                    {newData.map((item, index) => {


                        const highlighted = item.replace(
                            /Terms & Conditions/i,
                            '<span id="terms-conditions-link" style="color: #1D83BE; cursor: pointer;">Terms & Conditions</span>'
                        );

                        return (

                            <div key={index} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '8px' }}>
                                <span className="disclaimer-bullet" style={{ marginRight: '8px', fontSize: 25, color: 'black' }}>•</span>

                                <div >
                                    <div >

                                        {
                                            <div className='disclaimerText' dangerouslySetInnerHTML={{ __html: highlighted }} />}



                                    </div>
                                      </div>
                                    <div />
                                </div>
                                );
                    })}
                     {provisionalSaleDuration &&
                    provisionalSaleDuration !== 'null' &&
                    provisionalSaleDuration !== '' && (

                          <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '8px' }}>
                            <span className="disclaimer-bullet" style={{ marginRight: '8px', fontSize: 25, color: 'black' }}>•</span>


                                <div >
                                    <div className='disclaimerText'>


                                    { "Provisional sale start and end dates: " + provisionalSaleDuration}



                                    </div>
                                      </div>
                                    <div />
                                </div>

                    )}

                            </div>




            </div>

                );

}



                export default Disclaimer;